import type { ReactNode } from 'react';
import { Button } from '@shared/components';

interface Props {
    children: ReactNode;
    onClick: () => void;
    ariaDisabled?: boolean;
    disabled?: boolean;
}

const LINK_CLASS =
    'self-start text-sm font-medium text-mp-link underline underline-offset-2';

export function PanelLinkAction({ children, onClick, ariaDisabled = false, disabled = false }: Props) {
    return (
        <Button
            type="button"
            variant="clear"
            size="none"
            className={LINK_CLASS}
            ariaDisabled={ariaDisabled}
            disabled={disabled}
            onClick={onClick}
        >
            {children}
        </Button>
    );
}
